import { render } from "./BranchDotDialog.vue?vue&type=template&id=7ee798ae"
import script from "./BranchDotDialog.vue?vue&type=script&lang=js"
export * from "./BranchDotDialog.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__